import { LikesEffects } from './likes.effect';

export * from './likes.effect';

export const effects = [LikesEffects];
